module.exports = __webpack_public_path__ + "9ab213ac0042b7dad459e60ab713e086.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-police-s.png
// module id = 2890
// module chunks = 0